export const REQUEST_MRP = 'page/mrp/REQUEST_MRP';
export const HANDLE_RESPONSE_SUCCESS_MRP =
  'page/mrp/HANDLE_RESPONSE_SUCCESS_MRP';
export const HANDLE_RESPONSE_ERROR_MRP = 'page/mrp/HANDLE_RESPONSE_ERROR_MRP';
export const SET_MAKE_FILTER = 'page/mrp/SET_MAKE_FILTER';
export const RESET_MAKE_FILTER = 'page/mrp/RESET_MAKE_FILTER';
